export default "__VITE_ASSET__CNDoNg1G__"